<template>
<div class="DeviceElectrical">
  <div class="devcieContainer" :style="styleObject" v-if="JSON.stringify(tabData) == '{}'">
    <!-- <h4>设备列表</h4> -->
    <div class="treeAside">
      <div class="treeTop">
        <span class="treeTopTitle">区域</span>
      </div>
      <div class="treeBox">
        <el-tree
          lazy
          :load="loadData"
          :props="props"
          v-if="1"
          class="tree"
          ref="tree"
          :indent="6"
          node-key="value"
          highlight-current
          :expand-on-click-node="false"
          @node-click="handleNodeSelect">
          <span class="custom-tree-node" slot-scope="{ node }">
            <el-tooltip :content="node.label" placement="right-end" effect="light" :visible-arrow="true">
              <span class="treeLabel" style="width:190px">{{ showLabel(node.label) }}</span>
            </el-tooltip>
          </span>
        </el-tree>
        <!-- <el-tree v-if="1" ref="tree" class="tree" :indent=6 :data="treeData" how-checkbox node-key="value" default-expand-all highlight-current :expand-on-click-node="false" @node-click="handleNodeSelect">
          <span class="custom-tree-node" slot-scope="{ node }">
            <el-tooltip :content="node.label" placement="right-end" effect="light" :visible-arrow="true">
              <span class="treeLabel" style="width:190px">{{ showLabel(node.label) }}</span>
            </el-tooltip>
          </span>
        </el-tree> -->
      </div>
    </div>
    <div class="container">
      <div class="query">
        <div class="queryCons">
          <div class="common">
            <el-input placeholder="设备名称/设备类型/IMEI" autocomplete="off" v-model="searchText"></el-input>
            <div class="search" @click="serachData">
              <i><img src="../../assets/img/searchIcon.png" alt=""></i>
            </div>
          </div>
          <!-- <el-select class="common" v-model="keyWords.isInstall" placeholder="是否安装" clearable @change="isInstallChange">
            <el-option label="已安装" :value="1"></el-option>
            <el-option label="未安装" :value="0"></el-option>
          </el-select>
          <el-select class="common" v-model="keyWords.isRegist" placeholder="是否注册" clearable @change="isRegistChange">
            <el-option label="已注册" :value="1"></el-option>
            <el-option label="未注册" :value="0"></el-option>
          </el-select> -->
          <el-select class="common" v-model="keyWords.isOnline" placeholder="是否在线" clearable @change="isOnlineChange">
            <el-option label="在线" :value="true"></el-option>
            <el-option label="离线" :value="false"></el-option>
          </el-select>
          <!-- <el-select class="common" v-model="keyWords.typeId" placeholder="设备类型" clearable>
            <el-option v-for="(item,i) in deviceTypeList" :key="i" :label="item.name" :value="item.id"></el-option>
          </el-select> -->
          <el-select class="common" v-model="keyWords.isAlarm" placeholder="是否报警" clearable @change="isAlarmChange">
            <el-option label="报警" :value="true"></el-option>
            <el-option label="未报警" :value="false"></el-option>
          </el-select>
          <el-select class="common" v-model="keyWords.isFault" placeholder="是否故障" clearable @change="isFaultChange">
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>

          <el-button class="delSome" type="primary" size="medium" @click="changeRightCons" icon="el-icon-s-data">实时统计</el-button>
          <!-- <button class="primaryBtn common" @click="serachData">搜索</button> -->
          <!-- <button class="delSome" @click="changeRightCons">
            <i class="imgShow"><img src="../../assets/img/statistics.png" alt=""></i>
            <span>实时统计</span>
          </button> -->
        </div>
      </div>
      <div class="listsContainer" :style="styleObjectCons">
        <!-- :class="changeStatus?'':'active'" -->
        <div class="listsLeft">
          <el-scrollbar wrap-class="scrollbar-wrapper" v-loading="tableLoading">
            <ul class="clearfix cardList">
              <li v-for="(dataInfo,index) in dataList" :key="index">
                <card :showFields="fields" :info="dataInfo" @clickEven="clickEven"></card>
              </li>
            </ul>
          </el-scrollbar>
          <div class="noData" v-if="!(dataList&&dataList.length)&&consShow">
            <img src="../../assets/img/noData.png" alt="">
            <div class="tip">暂无数据</div>
          </div>
          <div class="cardPage">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.currentPage" :page-sizes="pagination.pageSizes" :page-size="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="maskingRight" v-if="changeStatus">
    <div class="listsRight" :class="showSlid?'component-slid-open' : 'component-slid-out'">
      <div class="messContainer">
        <div class="cons">
          <device-right-cons :typeId="deviceTypeId" @closeRightCons="closeRightCons"></device-right-cons>
        </div>
      </div>
    </div>
  </div>
  <div class="mainContent" :style="styleObject" v-if="JSON.stringify(tabData) != '{}'">
    <div class="navShow">
      <h3 v-if="JSON.stringify(tabData) == '{}'">设备列表</h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <template v-if="JSON.stringify(tabData) != '{}'">
          <el-breadcrumb-item :to="{ path: '/deviceElectrical' }">
            <span @click="jumpDev">设备列表</span>
          </el-breadcrumb-item>
          <template>
            <el-breadcrumb-item>{{tabData.name}}</el-breadcrumb-item>
          </template>
        </template>
      </el-breadcrumb>
    </div>
    <div class="tabBox">
      <tab-block @tabToggle="toggleCom" :pageType="pageType" :tabs="tabs"></tab-block>
    </div>
    <div class="main">
      <component :is="component" :deviceId="deviceId" :deviceImei="deviceImei"></component>
    </div>
  </div>
</div>
</template>

<script>
import TabBlock from '@/components/common/TabBlock'
import BasicInfo from '@/views/deviceManagement/deviceElectrical/BasicInfo'
import DeviceDatas from '@/views/deviceManagement/deviceDetails/DeviceDatas'
import IssueCommand from '@/views/deviceManagement/deviceDetails/IssueCommand'
import AlarmRecord from '@/views/deviceManagement/deviceDetails/AlarmRecord'
import FaultRecord from '@/views/deviceManagement/deviceDetails/FaultRecord'
import InstallRecord from '@/views/deviceManagement/deviceDetails/InstallRecord'
import DeviceRightCons from '@/views/deviceManagement/gatewayChild/DeviceRightCons'
import Card from '@/views/deviceManagement/deviceElectrical/Card'
export default {
  name: 'DeviceElectrical',
  components: {
    TabBlock,
    BasicInfo,
    DeviceDatas,
    IssueCommand,
    AlarmRecord,
    FaultRecord,
    InstallRecord,
    Card,
    DeviceRightCons
  },
  data() {
    return {
      treeData: [],
      searchText: '',
      keyWords: {
        isAlarm: "",
        isFault: "",
        isInstall: "",
        isOnline: "",
        isRegist: "",
        typeId: ''
      },
      options: [{
        value: '1',
        label: '在线'
      }, {
        value: '0',
        label: '离线'
      }],
      component: '',
      tabs: [{
          name: '基本信息',
          code: 'BasicInfo'
        }, {
          name: '设备数据',
          code: 'DeviceDatas'
        },
        // {
        //   name: '下发命令',
        //   code: 'IssueCommand'
        // },
        {
          name: '报警记录',
          code: 'AlarmRecord'
        }, {
          name: '故障记录',
          code: 'FaultRecord'
        }, {
          name: '安装记录',
          code: 'InstallRecord'
        }
      ],
      pageType: 'DeviceGas',
      styleObject: {
        height: ''
      },
      styleObjectCons: {
        height: ''
      },
      tabData: {},
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 12,
        pageSizes: [12, 22, 32],
        total: 0
      },
      dataList: [],
      deviceTypeList: [],
      fields: [],
      tableLoading: true,
      deviceId: null,
      getEchartStatus: '',
      deviceImei: '',
      changeStatus: false,
      consShow: false,
      currentTreeId: '',
      showSlid: false,
      deviceTypeId:3,
      props: {
        label: 'label',
        children: 'children',
        isLeaf: 'isLeaf'
      },
    }
  },
  created() {
    this.makeheight()
    this.makeheightCons()
    // this.queryTreeNode()
    // this.initData()
    // this.getDeviceType()
  },
  methods: {
    showLabel(label) {
      if (!label) {
        return label;
      }
      return label;
    },
    // 查询组织
    // queryTreeNode(pid = 0) {
    //   this.request.get(`/front/system/organization/findTreeById?id=${pid}`)
    //     .then(rs => {
    //       // console.log(rs);
    //       this.treeData = rs.code === 200 ? rs.data : [];
    //       this.currentTreeId = this.treeData.length > 0 ? this.treeData[0].value : 0;
    //     })
    //     .catch(error => (this.treeData = []));
    // },
    // 查询区域
    queryTreeNode(pid = 0) {
      this.request.get(`/front/device/region/findTreeById?id=${pid}`)
        .then(rs => {
          // console.log(rs);

          this.treeData = rs.code === 200 ? rs.data : [];
          this.currentTreeId = this.treeData.length > 0 ? (this.treeData[0].value?this.treeData[0].value:0):0;
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(this.treeData[0].value)
          })
          this.initData()
        })
        .catch(error => (this.treeData = []));
    },
    // 查询区域
    loadData (node, resolve) {
      if (node.level === 0) {
        let root = { id: 0, label: '区域机构', parentId: 0, value: 0 }
        
        //默认展开第一层根节点---节点渲染完成后，加载第二层节点的核心代码
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(0)
          let nodedata = node.childNodes[0];
          nodedata.expanded = true;
          nodedata.loadData();
        })
        resolve([root])
      } else {
        let pid = node.data ? node.data.id : 0

        this.request.get(`/front/device/region/findTreefenjiById?id=${pid}`).then(rs => {
          let data = rs.code === 200 ? rs.data : []

          // 区域-终端出库设备
          if (node.level == 1) {
            data.unshift({ id: -1, label: '终端出库设备', parentId: 0, value: -1, isLeaf: true })
          }

          this.initData()
          resolve(data)
          
        }).catch(error => {
          console.error(error)
          let temp = node.level == 1 ? [{ id: -1, label: '终端出库设备', parentId: 0, value: -1, isLeaf: true }] : []
          resolve(temp)
          // resolve([])
        })        
      }
    },    
    // 节点点击发生变化时，触发事件
    handleNodeSelect(item) {
      this.currentTreeId = item ? (item.value ? item.value : 0) : 0;
      this.pagination.currentPage = 1;
      this.initData();
    },
    getDeviceType() {
      this.request.post('/front/device/type/query', {
          page: 1,
          pageSize: 1000
        }).then(res => {
          console.log(res);
          if (res.code === 200) {
            this.deviceTypeList = res.data.data ? res.data.data : []
          } else if (res.code === 500) {
            this.deviceTypeList = []
            this.msg.warn(res.msg)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    serachData() {
      //查询//搜索
      this.getEchartStatus = this.keyWords.typeId
      this.searchText = this.searchText.replace(/(^\s*)|(\s*$)/g, "")
      this.pagination.currentPage = 1
      this.initData()
    },
    initData() {
      this.consShow = false
      this.params = {
        key: this.searchText,
        page: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        orgId: this.currentTreeId ? this.currentTreeId : 0,
        typeId: this.keyWords.typeId,
        isInstall: this.keyWords.isInstall,
        isAlarm: this.keyWords.isAlarm,
        isFault: this.keyWords.isFault,
        isRegist: this.keyWords.isRegist,
        isOnline: this.keyWords.isOnline,
      }
      let url = this.params.orgId == -1 ? '/front/device/electrical/queryOutbound' : "/front/device/electrical/query"
      this.request.get(url, this.params)
        .then(res => {
          console.log(res)
          if (res.code === 200) {
            this.tableLoading = false
            this.consShow = true
            this.dataList = res.data ? res.data : []
            this.pagination.total = res.total
            // this.dataList.forEach(item => {
            //   this.fields = [{
            //     field: 'imei',
            //     name: 'IMEI'
            //   },{
            //     field: 'isOnline',
            //     name: '在线状态'
            //   }, {
            //     field: 'isAlarm',
            //     name: '报警状态'
            //   },{
            //     field: 'typeName',
            //     name: '类型名称'
            //   }, {
            //     field: 'installLocation',
            //     name: '安装位置'
            //   },{
            //     field: 'updateTime',
            //     name: '更新时间'
            //   }]
            // })
            this.dataList.forEach(item=>{
              this.fields = [{
                field: 'imei',
                name: 'IMEI'
              },
              {
                field: 'syncTime',
                name: '同步时间'
              },
              // {
              //   field: 'registType',
              //   name: '注册类型'
              // },
              {
                field: 'isOnline',
                name: '在线状态'
              }, {
                field: 'isAlarm',
                name: '报警状态'
              },
              {
                field: 'installLocation',
                name: '安装位置'
              }, {
                field: 'createTime',
                name: '创建时间'
              }]
            })
          } else if (res.code === 500) {
            this.dataList = []
            this.msg.warn(res.msg)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    jumpDev() {
      this.tabData = {}
      this.initData()
    },
    toggleCom(tabCode) {
      // console.log(tabCode);
      this.tabData = tabCode
      this.component = tabCode.code
    },
    clickEven(val) {
      console.log(val);
      this.tabData = {
        name: '基本信息',
        code: 'BasicInfo'
      }
      this.deviceId = val.deviceId
      this.deviceImei = val.imei
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和makeheightCons
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    makeheightCons(height = 210) {
      let _this = this;
      _this.styleObjectCons.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObjectCons.height = window.innerHeight - height + "px";
        })();
      };
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.initData()
    },
    handleSizeChange(val) {
      this.pagination.currentPage = 1
      this.pagination.pageSize = val
      this.initData()
    },
    changeRightCons() {
      if (!this.changeStatus) {
        this.changeStatus = true
        this.showSlid = true
      } else {
        this.showSlid = false
        setTimeout(() => {
          this.changeStatus = this.showSlid
        }, 440)
      }
    },
    closeRightCons(data){
      this.showSlid = false
        setTimeout(() => {
          this.changeStatus = data
        }, 440)
    },
    isInstallChange(){
      this.pagination.currentPage = 1
      this.initData()
    },
    isRegistChange(){
      this.pagination.currentPage = 1
      this.initData()
    },
    isOnlineChange(){
      this.pagination.currentPage = 1
      this.initData()
    },
    isAlarmChange(){
      this.pagination.currentPage = 1
      this.initData()
    },
    isFaultChange(){
      this.pagination.currentPage = 1
      this.initData()
    },
  }
};
</script>

<style lang="scss" scoped>
.DeviceElectrical {
  // position: relative;

  .navShow {
    margin-left: 20px;
    overflow: hidden;
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 1px solid #f2f2f2;

    i {
      float: left;
      width: 16px;
      height: 16px;
      margin-right: 4px;

      img {
        width: 100%;
        height: 100%;
        vertical-align: unset;
      }
    }

    h3 {
      float: left;
      font-size: 16px;
      line-height: 16px;
      font-weight: 500;
      color: #7A7D81;
    }

    span {
      float: left;
      font-size: 16px;
      font-weight: 500;
      color: #7A7D81;
    }
  }

  .devcieContainer {
    margin: 10px;
    padding: 15px 20px;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;

    h4 {
      padding-bottom: 10px;
    }

    .container {
      padding: 0 10px 0 300px;
    }

    .query {
      padding-bottom: 10px;

      .queryCons {
        width: 100%;
        overflow: hidden;

        .common {
          float: left;
          margin-bottom: 5px;
          position: relative;
          .search{
            position: absolute;
            right: 10px;
            top: 0px;
            width: 40px;
            height: 40px;
            font-size: 0;
            z-index: 10;
            text-align: center;
            cursor: pointer;
            i{
              display: inline-block;
              width: 16px;
              height: 16px;
              cursor: pointer;
              margin-top: 12px;
              img{
                width: 100%;
                height: 100%;
              }
            }
          }
        }

        .primaryBtn {
          width: 82px;
          height: 40px;
          cursor: pointer;
          margin-right: 20px;
          font-size: 14px;
          line-height: 40px;
          border: 0;
          color: #FFFFFF;
          background: #1089FF;
          border-radius: 2px;

          &:hover {
            background: #0774e0;
          }
        }

        .delSome {
          // width: 102px;
          // cursor: pointer;
          float: right;
          // font-size: 0;
          // padding: 0 10px;
          // border: 0;
          // color: #FFFFFF;
          // background: #1089FF;
          // border-radius: 2px;
          // outline: unset;
          // overflow: hidden;

          // &:hover {
          //   background: #0774e0;
          // }

          // .imgShow {
          //   float: left;
          //   width: 16px;
          //   height: 16px;
          //   margin: 10px 6px 0 0;

          //   img {
          //     width: 100%;
          //     height: 100%;
          //     vertical-align: middle;
          //   }

          //   &.active {
          //     transform: rotate(180deg);
          //   }
          // }

          // span {
          //   float: left;
          //   font-size: 14px;
          //   line-height: 40px;
          // }
        }
      }
    }

    .listsContainer {
      overflow: hidden;
      position: relative;

      .listsLeft {
        float: left;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 0 0 60px;
        position: relative;
        background: #f2f2f2;

        .noData {
          position: absolute;
          top: 50%;
          left: 50%;
          margin-left: -150px;
          margin-top: -150px;
          text-align: center;

          img {
            width: 300px;
            height: 300px;
          }

          .tip {
            margin-top: 10px;
            font-size: 18px;
            color: #bbb;
          }
        }

        .cardList {
          height: 100%;
          width: 100%;

          // overflow-x: hidden;
          // overflow-y: auto;
          &>li {
            float: left;
            width: 314px;
            height: 230px;
            padding: 10px;
            box-sizing: border-box;
          }
        }

        .cardPage {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 50px;
          text-align: center;
          padding: 10px 0;
          box-sizing: border-box;
        }

        &.active {
          width: 100%;

          .cardList {
            height: 100%;
            width: 100%;
            overflow-x: hidden;
            overflow-y: auto;

            &>li {
              float: left;
              width: 20%;
              height: 240px;
            }
          }
        }
      }

    }
  }
  .maskingRight{
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0,0.4);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    .listsRight {
      position: absolute;
      right: 12px;
      top: 0;
      width: 740px;
      height: 100%;
      z-index: 9999;
      box-shadow: -2px 0 10px #ccc;
      background: #fff;

      &.component-slid-open {
        position: absolute;
        top: 0;
        right: 0;
        width: 740px;
        height: 100%;
        background: #fff;
        opacity: 1;
        animation: slid-open 0.5s ease;
      }

      &.component-slid-out {
        position: absolute;
        top: 0;
        right: 0;
        width: 740px;
        height: 100%;
        background: #fff;
        animation: slid-out 0.5s ease;
      }

      .messContainer {
        width: 100%;
        height: 100%;
        // padding-left: 10px;
        box-sizing: border-box;

        .cons {
          width: 100%;
          height: 100%;
          // background: #f3f3f3;
          // background: rgba(243,243,243,1);
        }
      }
    }
  }
  .mainContent {
    margin: 12px;
    padding: 15px 20px;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;
  }

  @keyframes slid-open {
    0% {
      transform: translateX(100%);
      opacity: 0;
    }

    100% {
      transform: translateX(0);
    }
  }

  @keyframes slid-out {
    0% {
      width: 600px;
      transform: translateX(0)
    }

    100% {
      transform: translateX(100%)
    }
  }
}
</style><style lang="scss">
.DeviceElectrical {
  .devcieContainer {
    position: relative;
    .query {
      // padding-left: 10px;

      .el-input {
        width: 260px;
        margin-right: 10px;
        .el-input__inner {
          line-height: 40px;
          height: 40px;
          // border:none;
          // outline: none;
        }
      }

      .el-select {
        width: 170px;
        margin-right: 10px;

        .el-input {
          width: 170px;
          margin-right: 10px;

          .el-input__inner {
            line-height: 40px;
            height: 40px;
            // border:none;
            // outline: none;
          }
        }
      }
    }

    .el-loading-mask {
      background-color: unset;
    }

    .treeAside {
      position: absolute;
      width: 300px;
      height: 100%;
      padding: 0px 10px 10px 10px;
      left: 0;
      top: 0;
      box-sizing: border-box;

      .treeTop {
        width: 280px;
        position: absolute;
        height: 40px;
        line-height: 40px;
        font-size: 0;
        font-weight: bold;
        top: 0px;
        z-index: 10;
        // background: #fff;
        padding-left: 20px;
        box-sizing: border-box;

        .treeTopTitle {
          margin-right: 115px;
          // width: 500px;
          font-size: 18px;
          color: #333;
        }

        .el-button {
          margin-left: -24px;
        }

        .complete {
          margin-left: 10px;
        }
      }

      .treeBox {
        overflow: hidden;
        height: calc(100% - 15px);
        border: 1px solid #ebeef5;
        padding: 40px 10px 10px;
        box-sizing: border-box;
        background: #fff;
        margin-top: 15px;
      }

      .tree {
        height: 100%;
        overflow: auto;

        .el-tree-node__content {
          height: 40px;
        }

        .custom-tree-node {
          height: 40px;
          line-height: 40px;
          width: 100%;

          .treeLabel {
            font-size: 14px;
            display: inline-block;
            width: 130px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .treeBtn {
            float: right;

            .el-button {
              margin-left: 0;
            }
          }
        }
      }
    }
  }

  .el-breadcrumb {
    display: inline-block;
    padding: 0;
    font-family: AlibabaPuHuiTi-Medium;
  }

  .el-breadcrumb__inner a,
  .el-breadcrumb__inner.is-link {
    color: #7A7D81;
    font-size: 16px;
    font-weight: 500;
  }

  .el-breadcrumb__separator {
    font-size: 16px;
    color: #7A7D81;
    margin: 0 5px;
    font-weight: 500;
  }

  .el-breadcrumb__inner {
    font-size: 16px;
    color: #7A7D81 !important;
    font-weight: 500 !important;
  }
}
</style>
